import { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiBase, withBase } from '../config/api'; // Adjust path if needed

// Your custom CSS
// import '../styles/Testimonials.css'; 

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(`${getApiBase()}/api/testimonials`);
        // Limit to 4 most recent, just like your design
        setTestimonials(res.data.slice(0, 4));
      } catch (err) {
        console.error("Failed to fetch testimonials", err);
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  if (loading) {
    return <div>Loading testimonials...</div>; // Or a spinner
  }

  if (testimonials.length === 0) {
    return null; // Don't show the section if there are no videos
  }

  return (
    <div className='container py-5'>
      <div className="row">
          <div className="col-12">
            <h1 className="custom-heading">Valuable Partner's Say</h1>
            <hr className="custom-divider" />
          </div>
        </div>
        <div className='row'>
            <div className="testimonials-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem', maxWidth: '1200px', margin: '0 auto', padding: '0 1rem'}}>
        
        {testimonials.map((video, index) => (
          <div 
            className="testimonial-video" 
            data-aos="fade-up" 
            data-aos-delay={`${(index + 1) * 100}`} 
            key={video.id}
          >
            {/* You can add the title here if you want */}
            {/* <h5 className="video-title">{video.title}</h5> */}
            <video controls muted style={{ width: '100%', borderRadius: '8px' }}>
              <source src={withBase(video.video_src)} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ))}

            </div>
        </div>
    </div>
  );
};

export default Testimonials;